/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M9.43 13.3q-.17-.24-.38-.44L4.99 8.83c-.28-.28-.32-.28-.6 0l-2.87 2.85-.4.4a.4.4 0 0 0-.02.55l.14.13 4 3.98q.1.12.23.2c.15.09.34.09.45-.04.25-.26.57-.46.72-.8q.02-.05.05-.06c.2-.06.33-.22.47-.36l.98-.98q.16-.12.22-.3.03-.05.08-.08.6-.38.99-.98l.05-.04c.36-.1.65-.34.96-.53q1.3-.75 2.56-1.58c.82-.55 1.62-1.13 2.3-1.85a6 6 0 0 0 1.22-1.8c.35-.93.24-1.81-.23-2.67q-.5-.88-1.2-1.6a11 11 0 0 0-1.74-1.5 4 4 0 0 0-1.65-.73q-.93-.16-1.74.33c-.3.18-.54.45-.8.67-.37.3-.57.7-.86 1.04q-.44.53-.77 1.12",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M8.84 2.26a1.3 1.3 0 0 0-1.05-.42c-.56 0-1.02.26-1.43.6a6 6 0 0 0-1.59 1.98q-.33.74-.27 1.56c.03.5.12.98.17 1.47q.06.58.02 1.15",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
